import React, { useEffect } from 'react';

import { routeInviteRequest } from '../../lib/inviteCodeRouter';
import { detectPlatform } from '../DeepLinkUtils';

export default function LocationInviteRedirect() {
  const params = new URLSearchParams(window.location.search);
  const segments = window.location.pathname.split('/').filter(Boolean);
  
  // Extract companyId and locationId from path: /signup/:companyId/:locationId
  const companyIdIndex = segments.indexOf('signup');
  const companyId = companyIdIndex !== -1 && segments[companyIdIndex + 1] ? segments[companyIdIndex + 1] : params.get('companyId') || undefined;
  const locationId = companyIdIndex !== -1 && segments[companyIdIndex + 2] ? segments[companyIdIndex + 2] : params.get('locationId') || undefined;
  
  // Check routing and redirect immediately
  useEffect(() => {
    const handleRouting = async () => {
      if (!companyId) {
        window.location.href = '/';
        return;
      }

      const platform = detectPlatform();
      const searchParams = new URLSearchParams();
      searchParams.set('companyId', companyId);
      if (locationId) searchParams.set('locationId', locationId);
      
      const routing = await routeInviteRequest(searchParams, platform);

      if (routing.shouldRedirectToMobile && routing.mobileDeepLink) {
        // Redirect to mobile app (only if explicitly from mobile app)
        window.location.href = routing.mobileDeepLink;
        return;
      }

      if (routing.shouldHandleWebSide && routing.webRoute) {
        // Handle web-side - redirect immediately
        window.location.replace(routing.webRoute);
        return;
      }

      // Fallback: redirect to signup page
      window.location.replace('/signup');
    };

    handleRouting();
  }, [companyId, locationId]);

  // Show loading state while routing
  return (
    <div className="min-h-screen bg-[#111010] flex items-center justify-center">
      <div className="text-white">Loading...</div>
    </div>
  );
}
